import { collection, addDoc, getDocs, query, where, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export const dataInitializer = {
  async initializeUserData(userId: string) {
    // Ensure default product exists for org (using userId as fallback org id if profile not loaded)
    try {
      const orgId = userId; // fallback; real orgId will be set elsewhere
      const qProd = query(collection(db, 'products'), where('orgId', '==', orgId));
      const snap = await getDocs(qProd);
      if (snap.empty) {
        await addDoc(collection(db, 'products'), {
          key: 'nach-kundenwunsch',
          name: 'Nach Kundenwunsch',
          type: 'service',
          leadStages: ['untouched','interested','demo','offer','closing','won','lost'],
          opportunityStages: ['prospecting','qualification','proposal','negotiation','closing','won','lost'],
          isDefault: true,
          orgId,
          createdAt: Timestamp.now(),
          updatedAt: Timestamp.now(),
        });
      }
    } catch (e) {
      // best effort only
      console.warn('Default product init skipped:', e);
    }
  }
};